export default __webpack_public_path__ + "static/media/craon14.909612ae.jpg";